import styled from 'styled-components';

import { media } from 'style-utils';

// Commented absolute positioning - NP383
export const FooterContainer = styled.div`
  border-top: ${props =>
    props.variant === 'white' ? 'none' : '1px solid #d6dbe4'};
  padding: 16px;
  background: ${props => (props.variant === 'white' ? 'white' : '#e6eaef')};
  & p {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: ${props => props.theme.color.brownGrey};
  }
  ${media.tablet`
    padding-bottom: 70px;
  `}

  ${media.mobile`
    padding-bottom: 70px;
  `}
`;
export const Links = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const LogoLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  ${media.mobile`
    margin-bottom: -20px;
  `}
`;

export const LinksWrapper = styled.div`
  width: 100%;
`;

export const LogoLink = styled.div`
  cursor: pointer;
  color: ${props => props.theme.color.brownGrey};

  font-size: 12px;
  text-decoration: none;
  text-align: center;
  padding: 0 15px;

  &:last-child {
    border: 0;
  }
  &:visited,
  &:active {
    color: ${props => props.theme.color.brownishGrey};
  }
  &:hover {
    color: ${props => props.theme.color.brownishGrey};
  }
  ${media.mobile`
    margin: 0 15px;
    padding: 12px 0;
    border-right: 0;
  `}
`;

export const FooterLinks = styled.div`
  cursor: pointer;
  color: ${props => props.theme.color.brownGrey};
  border-right: 1px solid ${props => props.theme.color.base3};

  font-size: 12px;
  text-decoration: none;
  text-align: center;
  padding: 0 20px;
  border-right: 1px solid ${props => props.theme.color.base3};

  &:last-child {
    border: 0;
  }
  &:visited,
  &:active {
    color: ${props => props.theme.color.base3};
  }
  &:hover {
    color: ${props => props.theme.color.base3};
  }
  ${media.mobile`
    width: 100%;
    padding: 10px 0;
    border-right: 0;
  `}
`;



// WEBPACK FOOTER //
// ./src/layouts/footer/style.js